import { render } from "./lab_results_modal2.vue?vue&type=template&id=37538381&scoped=true"
import script from "./lab_results_modal2.vue?vue&type=script&lang=js"
export * from "./lab_results_modal2.vue?vue&type=script&lang=js"

import "./lab_results_modal2.vue?vue&type=style&index=0&id=37538381&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37538381"]])

export default __exports__